const LOG_LEVELS = {
  DEBUG: 'DEBUG',
  INFO: 'INFO', 
  WARN: 'WARN',
  ERROR: 'ERROR'
} as const;

class Logger {
  private logToConsole(level: keyof typeof LOG_LEVELS, message: string, data?: any) {
    const timestamp = new Date().toISOString();
    const logMessage = `[${timestamp}] [${level}] ${message}`;
    
    switch(level) {
      case 'ERROR':
        console.error(logMessage, data);
        break;
      case 'WARN':
        console.warn(logMessage, data);
        break;
      case 'DEBUG':
        console.debug(logMessage, data);
        break;
      default:
        console.log(logMessage, data);
    }
  }

  debug(message: string, data?: any) {
    // DEBUG suprimido em produção (antes: modo demo)
    if (import.meta.env.PROD) {
      return;
    }
    this.logToConsole('DEBUG', message, data);
  }

  info(message: string, data?: any) {
    this.logToConsole('INFO', message, data);
  }

  warn(message: string, data?: any) {
    this.logToConsole('WARN', message, data);
  }

  error(message: string, error?: any) {
    this.logToConsole('ERROR', message, error);
  }
}

export const logger = new Logger();